/**
 * @generated SignedSource<<b7d0df2b93c942b803745dcb874d2a24>>
 * @relayHash 4f3f55dd0935f938ce90df303d5f42fc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 23411df53cd0fe85fedf02d23ee36d850dfcba7fbaa3348c9a491e8eb7403fbf

import type { ConcreteRequest } from 'relay-runtime';
export type ThemePreferenceQuerySelectorQuery$variables = Record<PropertyKey, never>;
export type ThemePreferenceQuerySelectorQuery$data = {
  readonly userPreferences: {
    readonly theme: string;
  } | null;
};
export type ThemePreferenceQuerySelectorQuery = {
  response: ThemePreferenceQuerySelectorQuery$data;
  variables: ThemePreferenceQuerySelectorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "UserPreferences",
    "kind": "LinkedField",
    "name": "userPreferences",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "theme"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ThemePreferenceQuerySelectorQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ThemePreferenceQuerySelectorQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "4f3f55dd0935f938ce90df303d5f42fc",
    "id": "23411df53cd0fe85fedf02d23ee36d850dfcba7fbaa3348c9a491e8eb7403fbf",
    "metadata": {},
    "name": "ThemePreferenceQuerySelectorQuery",
    "operationKind": "query",
    "text": "query ThemePreferenceQuerySelectorQuery{userPreferences{theme}}"
  }
};
})();

(node as any).hash = "6094bede1a0681395f400cd3cafa6bf9";

export default node;
